import { useTranslation } from 'react-i18next';
import { StatusChip } from '@/components/ui/Chip';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';
import { readCareCommunicationPriority } from '@/lib/medcom/careCommunicationPriority';

export function CareCommunicationPriorityChip({
  priority,
  variant = 'compact',
}: {
  priority?: string | null;
  /**
   * detail: Prioritet/Priority label + chip for asap and routine.
   * chip: chip only for asap and routine (label lives beside it).
   * compact: asap chip only (lists and thread).
   */
  variant?: 'detail' | 'chip' | 'compact';
}) {
  const { t } = useTranslation();
  const value = readCareCommunicationPriority(priority);
  if (!value) return null;

  const chip = (
    <StatusChip tone={value === 'asap' ? 'coral' : 'neutral'}>
      {t(`communicate.priority_display_${value}`)}
    </StatusChip>
  );

  switch (variant) {
    case 'compact':
      return value === 'asap' ? chip : null;
    case 'chip':
      return chip;
    case 'detail':
      return (
        <span className={cn('inline-flex flex-wrap items-center gap-s2', TYPE.small)}>
          <span className="text-ds-muted">{t('communicate.field_priority')}</span>
          {chip}
        </span>
      );
    default: {
      const unexpected: never = variant;
      return unexpected;
    }
  }
}
